// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s64b","type":"styles_type__5AZ05","choices":"styles_choices__1CeHv"};